// src/pages/OAuthCallbackPage.tsx
import React, { useCallback, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { SITE_URL } from '../../configurations/api/url';
import { Container, Box, Typography } from '@mui/material';
import { Spinner } from '@chakra-ui/react';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

const OAuthCallbackPage = () => {
    const { provider } = useParams();
    const location = useLocation();
    const code = new URLSearchParams(location.search).get('code');
    const { themeStyle } = useThemeContext();

    const exchange = useCallback(() => {
        const targetOrigin = new URL(SITE_URL).origin;

        if (code && provider) {
            window.opener?.postMessage(
                {
                    type: 'SOCIAL_AUTH_SUCCESS',
                    provider,
                    code,
                },
                targetOrigin,
            );
        } else {
            window.opener?.postMessage(
                {
                    type: 'SOCIAL_AUTH_FAILED',
                    provider,
                },
                targetOrigin,
            );
        }

        window.close();
    }, [code, provider]);

    useEffect(() => {
        exchange();
    }, [exchange]);

    return (
        <Container
            sx={{
                display: 'flex',
                height: '100vh',
                width: '100vw',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Box flexDirection="column" alignItems="center" justifyItems="center">
                <Spinner color={theme[themeStyle].tag_white} height={100} width={100} />
                <Typography variant="h6" mt={2} sx={{ color: theme[themeStyle].tag_white }}>
                    Logging in via {provider}...
                </Typography>
            </Box>
        </Container>
    );
};

export { OAuthCallbackPage };
